var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyTeam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 52C66 55.3137 63.3138 58 60 58C56.6863 58 54 55.3137 54 52C54 48.6863 56.6863 46 60 46C63.3138 46 66 48.6863 66 52Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56C76 58.2091 74.2092 60 72 60C69.7908 60 68 58.2091 68 56C68 53.7909 69.7908 52 72 52C74.2092 52 76 53.7909 76 56Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68 70C68 65.5818 64.4182 62 60 62C55.5817 62 52 65.5818 52 70V76H68V70Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 56C52 58.2091 50.2091 60 48 60C45.7909 60 44 58.2091 44 56C44 53.7909 45.7909 52 48 52C50.2091 52 52 53.7909 52 56Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0001 76V70C72.0001 67.8918 71.4565 65.9104 70.5015 64.1886C70.9805 64.0654 71.4827 64 72.0001 64C75.3139 64 78.0001 66.6862 78.0001 70V76H72.0001Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4985 64.1886C48.5437 65.9104 48 67.8918 48 70V76H42V70C42 66.6862 44.6863 64 48 64C48.5174 64 49.0195 64.0654 49.4985 64.1886Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTeam);
export default __webpack_public_path__ + "static/media/MyTeam.36682bf17ee9fdbf801926071e82c52e.svg";
export { ForwardRef as ReactComponent };